export const translationKO = {
  top: {
    text_1: '신선한 음식 & 더 나은 지구',
    text_2: 'AI가 추천',
    text_3: '수천 레시피',
    text_4: '재료를 관리하는 데 도움을 주는 공간',
    text_5: '다양한 요리의 레시피',
    text_6: '주간 메뉴, 쇼핑 리스트',
  },
  main_function: {
    text_1: '주요 기능',
    text_1_1: '음식을 신선하게 유지하세요!',
    text_1_2: '신선도 체커로부터 알림을 받아 음식을 버리지 않도록 도와줍니다',
    text_2_1: 'AI 레시피 추천',
    text_2_2: '냉장고에 남은 재료를 기반으로 세계 여러 요리의 레시피를 발견하세요',
    text_3_1: '한 주간의 메뉴',
    text_3_2: '한 주간의 메뉴를 만드세요',
    text_4_1: '쇼핑 리스트',
    text_4_2: '쇼핑 준비를 위해 쇼핑 리스트를 만들고 업데이트하세요',
    text_5: '다운로드',
    text_6: 'iFridge가 당신을 도와줍니다',
    text_7_1: '더 나은 주부가 되세요',
    text_7_2: '쓰레기를 줄이고 더 건강한 지구를 만드세요',
    text_7_3: '요리를 즐기세요',
  },
  rate_box: {
    text_1: '사용자 리뷰',
  },
  faqs: {
    text_1: '자주 묻는 질문',
    text_2_1: '어떤 종류의 계정이 있나요? 무료로 앱을 사용할 수 있나요?',
    text_2_2: `첫 한 달 동안 앱의 모든 기능을 무료로 광고 없이 사용할 수 있습니다.
      <br /><br />첫 한 달이 끝나면 계정은 자동으로 무료 계정으로 전환됩니다.
      <br /><br />무료 계정으로는 재료 관리, 일일 재료 상태 보고서 등 앱의 기본 기능을 사용할 수 있습니다. 하지만 AI 레시피 추천, 주간 메뉴, 쇼핑 리스트 등 일부 고급 기능은 사용할 수 없습니다. 앱을 사용할 때 광고가 표시됩니다.
      <br /><br />모든 기능을 광고 없이 사용하려면, 매우 저렴한 월 요금으로 프리미엄 계정으로 업그레이드해야 합니다.`,
    text_3_1: '프리미엄 계정의 비용은 얼마인가요?',
    text_3_2: `월별 또는 연간 구독이 가능합니다.
      <br /><br />월 요금: $0.99/월.
      <br /><br />연 요금: $9.99/년.
      <br /><br />추가 비용은 없습니다.`,
    text_4_1: '돈을 내지 않고 프리미엄 계정을 구독할 수 있나요?',
    text_4_2: `물론 가능합니다.
      <br /><br />프리미엄 계정을 구독하려면 iFridge 포인트를 사용하세요.
      <br /><br />iFridge 포인트는 설정 화면의 포인트 메뉴에서 앱 스토어/Google Play를 통해 구매할 수 있습니다.
      <br /><br />또는 광고를 시청하여 iFridge 포인트를 획득할 수 있습니다: 설정 화면의 기타 설정 메뉴에서 광고 시청 옵션을 선택하세요.`,
    text_5_1: '광고를 시청하면 iFridge 포인트를 받을 수 있나요?',
    text_5_2: `광고를 시청하면 iFridge 포인트를 받을 수 있습니다.
      <br /><br />사용자의 국가에 따라 광고 한 편 시청 시 일정 수의 iFridge 포인트를 받을 수 있습니다 (Google Admob 규정에 따름). 광고를 시청한 후 20분을 기다려야 다음 광고를 시청할 수 있습니다.`,
    text_6_1: '친구를 추천하여 iFridge 포인트를 받을 수 있나요?',
    text_6_2: `물론 가능합니다.
      <br /><br />Facebook, Twitter와 같은 소셜 네트워크를 통해 iFridge 정보를 공유하면 일정 수의 iFridge 포인트를 받을 수 있습니다.
      <br /><br />한 달에 한 번, 친구 추천으로 iFridge 포인트를 받을 수 있습니다.`,
    text_7_1: '내 개인 데이터는 안전하게 보관되나요? 제3자와 공유되나요?',
    text_7_2:
      '귀하의 데이터는 전적으로 귀하의 휴대폰에 저장되며, 완전히 안전하게 보호됩니다. 당사는 귀하의 개인 데이터를 서버에 저장하거나 제3자와 공유하지 않습니다.',
    text_8_1: '지원이 필요하면 어떻게 연락할 수 있나요?',
    text_8_2: `설정 화면에서 기타 설정 메뉴를 선택하고, 문의하기 옵션을 통해 저희에게 연락할 수 있습니다.
      <br /><br />또는 다음 이메일로 직접 지원 요청/피드백을 보내세요: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: '사랑은 왔다가 갈 수 있지만,',
    text_2: '배고픔은 매일 찾아옵니다',
  },
};
